import React from 'react';
import {
  CertificationAndLicense,
  CompanyAdminMeta,
} from '@dispatch/shared/types';
import { AdminDashboardTable } from './AdminDashboardTable';
import { actionsColumn, clickToCopy, textColumn } from '@dispatch/web/ui';
import { GridActionsCellItem, GridColumns } from '@mui/x-data-grid';
import { GridRowParams } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { handleModalOpen, onClick } from './helpers';

export const CertAndLicenseAdmin = ({
  certsAndLicense = [],
  modalState,
  isLoading,
}: {
  certsAndLicense?: CertificationAndLicense[];
  modalState?: {
    meta: CompanyAdminMeta;
    setmeta: React.Dispatch<CompanyAdminMeta>;
  };
  isLoading?: boolean;
}) => {
  const handleClick = React.useCallback(
    (params: GridRowParams) => onClick('addCertAndLicense', params, modalState),
    [modalState?.meta.addAttribute]
  );

  const handleDelete = React.useCallback(
    (params: GridRowParams & { type?: string }) => {
      params.type = 'certificationAndLicense';
      onClick('delete', params, modalState);
    },
    [modalState?.meta]
  );

  const columns: GridColumns = [
    clickToCopy({
      field: 'integrationGUID',
      headerName: 'ID',
      flex: 2,
    }),
    textColumn({
      field: 'name',
      headerName: 'Name',
      flex: 2,
    }),
    actionsColumn((params: GridRowParams) => [
      <GridActionsCellItem
        icon={<EditIcon />}
        label="EDIT"
        onClick={() => {
          handleClick(params);
        }}
        showInMenu
      />,
      <GridActionsCellItem
        icon={<DeleteIcon />}
        label="DELETE"
        onClick={() => {
          handleDelete(params);
        }}
        showInMenu
      />,
    ]),
  ];

  return (
    <AdminDashboardTable<CertificationAndLicense>
      isLoading={isLoading}
      columns={columns}
      data={certsAndLicense}
      type="license-and-certificate"
      buttonTitle="Add License/Certificate"
      identifier="integrationGUID"
      handleClick={() => handleModalOpen('addCertAndLicense', modalState)}
    />
  );
};
